import { Publish, Restore } from '@material-ui/icons';
import React, { useState } from 'react';
import CustomDraggableDialog from '../customDialog/CustomDraggableDialog';
import CustomButton from './CustomButton';
import TranslatedMessage from '../../translations/TranslatedMessage';

interface DefaultPublishArchiveButtonsProps {
  isPublishButtonEnabled?: boolean;
  isArchiveButtonEnabled?: boolean;
  isPublishButtonVisible?: boolean;
  isArchiveButtonVisible?: boolean;
  onPublish?: () => void;
  onArchive?: () => void;
}

const DefaultPublishArchiveButtons: React.FunctionComponent<DefaultPublishArchiveButtonsProps> = (props) => {
  const [isPublishDialogOpen, showPublishDialogOpen] = useState(false);
  const [isArchiveDialogOpen, showArchiveDialogOpen] = useState(false);

  const archiveButton = props.isArchiveButtonVisible ?
    <CustomButton disabled={false}
        tooltip={<TranslatedMessage id="common.archive" />} onClick={() => showArchiveDialogOpen(true)} >
        <Restore />
    </CustomButton>
    : <React.Fragment />;

  const publishButton = props.isPublishButtonVisible ?
    <CustomButton disabled={false}
        tooltip={<TranslatedMessage id="common.publish" />} onClick={() => showPublishDialogOpen(true)} >
        <Publish />
    </CustomButton>
    : <React.Fragment />;

  return (
    <React.Fragment>
      {publishButton}
      {archiveButton}
      <CustomDraggableDialog
          acceptText={<TranslatedMessage id="common.ok" />}
          cancelText={<TranslatedMessage id="common.cancel" />}
          content={<TranslatedMessage id="common.confirmArchiveDescription" />}
          isOpen={isArchiveDialogOpen}
          onAccept={props.onArchive}
          onCancel={() => showArchiveDialogOpen(false)}
          title=" "
        />

        <CustomDraggableDialog
          acceptText={<TranslatedMessage id="common.ok" />}
          cancelText={<TranslatedMessage id="common.cancel" />}
          content={<TranslatedMessage id="common.confirmPublishDescription" />}
          isOpen={isPublishDialogOpen}
          onAccept={() => {
            showPublishDialogOpen(false);
            props.onPublish && props.onPublish();
          }}
          onCancel={() => showPublishDialogOpen(false)}
          title=" "
        />
    </React.Fragment>
  );
}

DefaultPublishArchiveButtons.defaultProps = {
    isPublishButtonEnabled: true,
    isArchiveButtonEnabled: true,
    isPublishButtonVisible: true,
    isArchiveButtonVisible: true,
    onPublish: () => { },
    onArchive: () => { }
} as Partial<DefaultPublishArchiveButtonsProps>;

export default DefaultPublishArchiveButtons;
